import { sanitizeHTML } from '@benzinga/frontend-utils';
import styles from './StatBox.module.scss';

interface StatBoxProps {
  className?: string;
  title: string;
  value: string | number;
}

export const StatBox = ({ className, title, value }: StatBoxProps) => {
  return (
    <div className={`${styles.statBoxWrapper} stat-card card ${className ?? ''}`}>
      <div className="card-title" dangerouslySetInnerHTML={{ __html: sanitizeHTML(title) }}></div>
      <div className="card-value">{value}</div>
    </div>
  );
};

export default StatBox;
